import { PlacementPositions } from "../../../../enums/PlacementPositionsEnums";
import styles from "./QuarryMaterialList.module.scss";
import PhotoIcon from "../../../../assets/images/photo-preview.svg";
import MoreEllipsis from "../../../../assets/images/ellipsisListing.svg";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { Popover } from "antd";
import * as Yup from "yup";
import DescriptionCell from "../../../../reusable-components/DescriptionCell";
import { formatNumber } from "../../../../utils/numberFormatterUtil";
import { getPlaceholderForEmptyString } from "../../../../utils/emptyStringCheck";

export const subCategoryColumns = ({
  handleSetPhotoModalOpen,
  handleSetDeleteModalOpen,
  handleSetIsEditMaterialOpen,
}) => [
  {
    title: "MATERIAL NAME",
    key: "materialName",
    width: "200px",
    dataIndex: "materialName",
  },
  {
    title: "PRICE",
    key: "price",
    width: "180px",
    dataIndex: "price",
    render: (val, record) => (
      <span>{`$${formatNumber(Number(val).toFixed(2))} ${record?.quantityType ? `/ ${record?.quantityType}` : ""}`}</span>
    ),
  },
  {
    title: "MATERIAL TAX",
    key: "materialTax",
    width: "140px",
    dataIndex: "materialTax",
  },
  {
    title: "WASHED",
    key: "materialStatus",
    width: "80px",
    dataIndex: "materialStatus",
  },
  {
    title: "TESTING",
    key: "materialTest",
    width: "180px",
    dataIndex: "materialTest",
  },
  {
    title: "SUPPLY",
    key: "materialSupply",
    dataIndex: "materialSupply",
    width: "180px",
  },
  {
    title: "DESCRIPTION",
    key: "materialNotes",
    dataIndex: "materialNotes",
    width: "180px",
    render: (val) => (
      <span>
        <DescriptionCell text={getPlaceholderForEmptyString(val)} />
      </span>
    ),
  },
  {
    key: "actions",
    dataIndex: "actions",
    fixed: "right",
    width: "65px",
    render: (_, record) => {
      return (
        <Popover
          placement={PlacementPositions.LEFT}
          content={
            <>
              <div
                className={styles.PopoverContent}
                onClick={() => {
                  handleSetPhotoModalOpen?.(record?.id);
                }}
              >
                <img src={PhotoIcon} alt={""} />
                Pictures
              </div>
              <div
                className={styles.PopoverContent}
                onClick={() => {
                  handleSetIsEditMaterialOpen?.(record);
                }}
              >
                <MdModeEdit />
                Edit
              </div>
              <div
                className={styles.PopoverContent}
                onClick={() => {
                  handleSetDeleteModalOpen?.(record?.id);
                }}
              >
                <MdDelete />
                Delete
              </div>
            </>
          }
        >
          <span className={styles.moreEllipsis}>
            <img src={MoreEllipsis} alt={""} />
          </span>
        </Popover>
      );
    },
  },
];

export const deleteFormSchema = Yup.object({
  archiveReason: Yup
    .string()
    .trim()
    .required("Required for deletion"),
});
